import { BLANK_VALUE } from "./formatters";
import { CarbonUnit, UnitNumberType } from "portal/utils/units/units";
import { CycleSlot } from "portal/utils/metrics";
import { NumericMeasurement } from "./NumericMeasurement";
import { withErrorBoundary } from "../ErrorBoundary";
import React, { FC, ReactNode } from "react";

export type MeasurementProps = {
  cycleSlot?: CycleSlot;
  label?: "long" | "none";
  unit?: CarbonUnit;
  value: number | string | undefined;
};

/**
 * Generic Measurement display for when you need to show a number but don't
 * have a corresponding Metric definition. Prefer BooleanMeasurement or
 * NumericMeasurement if you know the value is limited to one of those types
 **/
const _Measurement: FC<MeasurementProps> = ({
  unit = UnitNumberType.COUNT,
  value,
  ...props
}): ReactNode => {
  if (value === undefined) {
    return BLANK_VALUE;
  } else if (typeof value === "string") {
    return value;
  }
  return <NumericMeasurement unit={unit} value={value} {...props} />;
};
_Measurement.displayName = "Measurement";

export const Measurement = withErrorBoundary(
  {
    i18nKey: "utils.descriptors.error",
    small: true,
  },
  _Measurement
);
